var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgOctorionCenterPointer = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 70,
    viewBox: "0 0 111 70",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 46)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 4.529,
    fill: "#BB2025"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 7.118,
    stroke: "#BB2025",
    opacity: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    stroke: "#BB2025",
    opacity: 0.267
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#373D40",
    strokeDasharray: 4,
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M36,-26 L83,-26 L83,73",
    transform: "rotate(-90 59.5 23.5)"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgOctorionCenterPointer, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/octorion-center-pointer.d4ddcf60.svg";
export { ForwardRef as ReactComponent };